import { render, staticRenderFns } from "./chartofaccount.vue?vue&type=template&id=27ae4be4&"
import script from "./chartofaccount.vue?vue&type=script&lang=js&"
export * from "./chartofaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports